/** Chip — small pill badge, optional violet variant. */
export function Chip({ label, v }) {
  return <span className={`chip${v ? ' chip-v' : ''}`}>{label}</span>
}
